
const digest = '73c9df43db87a2884ba72e81a3f7272f6d3124b7b298aeaa9b1956fa7ba8e61f';
const classes = {"wrapper":"_wrapper_j48u7_1","name":"_name_j48u7_16","content":"_content_j48u7_21","subject":"_subject_j48u7_26","badge":"_badge_j48u7_30","red":"_red_j48u7_39","attachment":"_attachment_j48u7_42","date":"_date_j48u7_47","active":"_active_j48u7_51","messagesList":"_messages-list_j48u7_55","item":"_item_j48u7_55"};
const css = `._wrapper_j48u7_1 {
  display: flex;
  flex-direction: row;
  padding: 24px;
  border: 1px solid #eaedf3;
  align-items: center;
  background-color: #ffffff;
  cursor: pointer;
}
._wrapper_j48u7_1:hover {
  text-decoration: none;
}
._wrapper_j48u7_1:nth-child(even) {
  background-color: #fbfbfd;
}
._wrapper_j48u7_1 ._name_j48u7_16 {
  font-size: 14px;
  color: #3e3f42;
  min-width: 230px;
}
._wrapper_j48u7_1 ._content_j48u7_21 {
  font-size: 14px;
  color: #787c88;
  flex-grow: 1;
}
._wrapper_j48u7_1 ._content_j48u7_21 ._subject_j48u7_26 {
  color: #3e3f42;
  font-weight: 600;
}
._wrapper_j48u7_1 ._content_j48u7_21 ._badge_j48u7_30 {
  background-color: #3e3f42;
  padding: 2px 5px;
  border-radius: 4px;
  color: #ffffff;
  margin-right: 5px;
  font-size: 12px;
  font-weight: 500;
}
._wrapper_j48u7_1 ._content_j48u7_21 ._badge_j48u7_30._red_j48u7_39 {
  background-color: #f12848;
}
._wrapper_j48u7_1 ._attachment_j48u7_42 img {
  height: 20px;
  margin-right: 15px;
  opacity: 0.7;
}
._wrapper_j48u7_1 ._date_j48u7_47 {
  color: #3e3f42;
  font-size: 12px;
}
._wrapper_j48u7_1._active_j48u7_51 {
  border-color: #d8dce4;
  box-shadow: 0 2px 5px 0 #f1f1f3;
}
._wrapper_j48u7_1._active_j48u7_51 ._messages-list_j48u7_55 ._item_j48u7_55 ._name_j48u7_16 {
  color: #000000;
}
._wrapper_j48u7_1._active_j48u7_51 ._messages-list_j48u7_55 ._item_j48u7_55 ._content_j48u7_21 {
  color: #000000;
}
._wrapper_j48u7_1._active_j48u7_51 ._messages-list_j48u7_55 ._item_j48u7_55 ._date_j48u7_47 {
  color: #000000;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  